import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const ServiceRow = ({service, index}) => {

    const {img, title} = service;

    return (
        <tr>
            <th>{index + 1}</th>
            <td>
                <img className='h-16' src={img} alt='project_coverImg' />
            </td>
            <td className='font-bold text-green-500'>{title}</td>
            <td /* onClick={() => setDeleteProject(project)} */ >
                <label /* setDeleteProject={setDeleteProject} */ htmlFor="delete-Confirm-Modal" className="btn btn-sm border-0 bg-red-300 text-red-500  modal-button">
                    Delete <FontAwesomeIcon className='ml-2' icon={faTrashCan} />
                </label>
            </td>
        </tr>
    );
};

export default ServiceRow;